import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ReleaseNote } from 'src/app/models/release-note';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { StudyState } from 'src/app/dashboard/state/study/study.reducer';
import { selectIsSideNavOpen } from 'src/app/dashboard/state/study/study.selectors';
import { ReleaseNoteState } from 'src/app/dashboard/state/release-note/release-note.reducer';
import {
  selectReleaseNotes,
  selectIsReleaseNotesLoaded,
} from 'src/app/dashboard/state/release-note/release-notes.selector';
import { MatDialog } from '@angular/material/dialog';
import { deleteReleaseNote } from 'src/app/dashboard/state/release-note/release-note.actions';
import { CreateReleaseNoteDialogComponent } from 'src/app/dashboard/settings/create-release-note/create-release-note-dialog.component';

@Component({
  selector: 'dashboard-release-notes-list',
  templateUrl: './release-notes-list.component.html',
  styleUrls: ['./release-notes-list.component.scss'],
})
export class ReleaseNotesListComponent implements OnInit {
  @ViewChild('deleteDialog')
  deleteDialogTemplate: TemplateRef<any>;

  releaseNotes$: Observable<ReleaseNote[]>;
  isReleasesReady$: Observable<boolean>;
  isSideNavOpen$: Observable<boolean>;

  selectedReleaseNote: ReleaseNote;

  constructor(
    private studyStore: Store<StudyState>,
    private releaseNotesStore: Store<ReleaseNoteState>,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.releaseNotes$ = this.releaseNotesStore.select(selectReleaseNotes);
    this.isReleasesReady$ = this.releaseNotesStore.select(selectIsReleaseNotesLoaded);
    this.isSideNavOpen$ = this.studyStore.select(selectIsSideNavOpen);
  }

  openDeleteReleaseNoteDialog(releaseNote: ReleaseNote) {
    this.selectedReleaseNote = releaseNote;
    this.dialog.open(this.deleteDialogTemplate);
  }

  deleteReleaseNote() {
    this.releaseNotesStore.dispatch(deleteReleaseNote({ releaseNoteId: this.selectedReleaseNote.id }));
    this.dialog.closeAll();
  }

  openEditReleaseNoteDialog(releaseNote: ReleaseNote) {
    this.selectedReleaseNote = releaseNote;
    this.dialog.open(CreateReleaseNoteDialogComponent, {
      width: '100%',
      data: { releaseNote },
    });
  }
}
